/**
 * Static item catalog for drag-and-drop hint slots.
 * Uses classic OoT icons (same images as the old OotItemAutocomplete).
 */

// Classic icons
import BombBag from '@/core/assets/oot/classic/OoT_Bomb_Bag_Model.png';
import Bow from '@/core/assets/oot/classic/OoT_Fairy_Bow_Icon.png';
import Slingshot from '@/core/assets/oot/classic/OoT_Fairy_Slingshot_Icon.png';
import Boomerang from '@/core/assets/oot/classic/OoT_Boomerang_Icon.png';
import Ocarina from '@/core/assets/oot/classic/OoT_Fairy_Ocarina_Icon.png';
import Bombchus from '@/core/assets/oot/classic/OoT_Bombchu_Icon.png';
import Hookshot from '@/core/assets/oot/classic/OoT_Hookshot_Icon.png';
import Hammer from '@/core/assets/oot/classic/OoT_Megaton_Hammer_Icon.png';
import FireArrow from '@/core/assets/oot/classic/OoT_Fire_Arrow_Icon.png';
import IceArrow from '@/core/assets/oot/classic/OoT_Ice_Arrow_Icon.png';
import LightArrow from '@/core/assets/oot/classic/OoT_Light_Arrow_Icon.png';
import DinsFire from "@/core/assets/oot/classic/OoT_Din's_Fire_Icon.png";
import FaroresWind from "@/core/assets/oot/classic/OoT_Farore's_Wind_Icon.png";
import RutoLetter from '@/core/assets/oot/classic/OoT_Letter_Icon.png';
import Bottle from '@/core/assets/oot/classic/OoT_Bottle_Icon.png';
import BlueFire from '@/core/assets/oot/classic/OoT_Blue_Fire_Icon.png';
import BigPoe from '@/core/assets/oot/classic/OoT_Big_Poe_Soul_Icon.png';
import Prescription from '@/core/assets/oot/classic/OoT_Prescription_Icon.png';
import EyeballFrog from '@/core/assets/oot/classic/OoT_Eyeball_Frog_Icon.png';
import Eyedrop from "@/core/assets/oot/classic/OoT_World_s_Finest_Eye_Drops_Icon.png";
import ClaimCheck from '@/core/assets/oot/classic/OoT_Claim_Check_Icon.png';
import WeirdEgg from '@/core/assets/oot/classic/OoT_Weird_Egg_Icon.png';
import KokiriSword from '@/core/assets/oot/classic/OoT_Kokiri_Sword_Icon.png';
import BiggoronSword from "@/core/assets/oot/classic/OoT_Giant's_Knife_Icon.png";
import DekuShield from '@/core/assets/oot/classic/OoT_Deku_Shield_Icon.png';
import HylianShield from '@/core/assets/oot/classic/OoT_Hylian_Shield_Icon.png';
import MirrorShield from '@/core/assets/oot/classic/OoT_Mirror_Shield_Icon.png';
import MagicMeter from '@/core/assets/oot/classic/OoT_Magic_Jar_Model.png';
import Wallet from '@/core/assets/oot/classic/OoT_Adult_s_Wallet_Icon.png';
import GerudoCard from '@/core/assets/oot/classic/OoT_Gerudo_Token_Icon.png';
import GoronTunic from '@/core/assets/oot/classic/OoT_Goron_Tunic_Icon.png';
import ZoraTunic from '@/core/assets/oot/classic/OoT_Zora_Tunic_Icon.png';
import Scale from '@/core/assets/oot/classic/OoT_Silver_Scale_Icon.png';
import Strength from "@/core/assets/oot/classic/OoT_Goron_s_Bracelet_Icon.png";
import IronBoots from '@/core/assets/oot/classic/OoT_Iron_Boots_Icon.png';
import HoverBoots from '@/core/assets/oot/classic/OoT_Hover_Boots_Icon.png';
import SmallKey from '@/core/assets/oot/classic/OoT_Small_Key_Model.png';
import BossKey from '@/core/assets/oot/classic/OoT_Boss_Key_Model.png';
import LensOfTruth from '@/core/assets/oot/classic/OoT_Lens_of_Truth_Icon.png';
import Deadge from '@/core/assets/oot/classic/deadge.png';

// Songs
import ZeldaLullaby from '@/core/assets/oot/song/zelda-lullaby.png';
import SariaSong from '@/core/assets/oot/song/saria.png';
import EponaSong from '@/core/assets/oot/song/epona.png';
import SunSong from '@/core/assets/oot/song/sun.png';
import SongOfTime from '@/core/assets/oot/song/time.png';
import SongOfStorm from '@/core/assets/oot/song/storm.png';
import Prelude from '@/core/assets/oot/song/prelude.png';
import Minuet from '@/core/assets/oot/song/minuet.png';
import Bolero from '@/core/assets/oot/song/bolero.png';
import Serenade from '@/core/assets/oot/song/serenade.png';
import Nocturne from '@/core/assets/oot/song/nocturne.png';
import Requiem from '@/core/assets/oot/song/requiem.png';

export interface OotItemData {
  name: string;
  tags: string[];
  img: string;
}

export const OOT_ITEMS: OotItemData[] = [
  { name: 'Deadge', tags: ['dead', 'sold out', 'nothing', 'rien'], img: Deadge },
  { name: 'Bomb Bag', tags: ['BB'], img: BombBag },
  { name: 'Bow', tags: ['Arc'], img: Bow },
  { name: 'Slingshot', tags: ['Lance', 'Pierre'], img: Slingshot },
  { name: 'Boomerang', tags: ['Lance', 'Pierre'], img: Boomerang },
  { name: 'Ocarina', tags: [], img: Ocarina },
  { name: 'Bombchus', tags: [], img: Bombchus },
  { name: 'Hookshot Upgrade', tags: [], img: Hookshot },
  { name: 'Megaton Hammer', tags: [], img: Hammer },
  { name: 'Fire Arrow', tags: [], img: FireArrow },
  { name: 'Ice Arrow', tags: ['Blue Arrow'], img: IceArrow },
  { name: 'Light Arrow', tags: [], img: LightArrow },
  { name: "Din's Fire", tags: ['Feu'], img: DinsFire },
  { name: "Farore's Wind", tags: ['Feu'], img: FaroresWind },
  { name: 'Lens of Truth', tags: ['Loupe'], img: LensOfTruth },
  { name: "Ruto's Letter", tags: ['Lettre'], img: RutoLetter },
  { name: 'Bottle', tags: ['Bouteille'], img: Bottle },
  { name: 'Blue Fire', tags: ['Bouteille'], img: BlueFire },
  { name: 'Big Poe', tags: ['Bouteille', 'Bottle'], img: BigPoe },
  { name: 'Prescription', tags: [], img: Prescription },
  { name: 'Eyeball Frog', tags: ['Grenouille'], img: EyeballFrog },
  { name: 'Eyedrop', tags: ['World', 'Finest', 'Goutte'], img: Eyedrop },
  { name: 'Claim Check', tags: [], img: ClaimCheck },
  { name: 'Weird Egg', tags: ['Oeuf', 'Bizarre'], img: WeirdEgg },
  { name: 'Kokiri Sword', tags: ['KS'], img: KokiriSword },
  { name: 'Biggoron Sword', tags: ['BGS'], img: BiggoronSword },
  { name: 'Deku Shield', tags: ['Key'], img: DekuShield },
  { name: 'Hylian Shield', tags: ['Key'], img: HylianShield },
  { name: 'Mirror Shield', tags: ['MS'], img: MirrorShield },
  { name: 'Magic Meter', tags: ['Magie'], img: MagicMeter },
  { name: 'Wallet', tags: ['Bourse'], img: Wallet },
  { name: "Gerudo's Card", tags: ['Token'], img: GerudoCard },
  { name: 'Goron Tunic', tags: [], img: GoronTunic },
  { name: 'Zora Tunic', tags: [], img: ZoraTunic },
  { name: 'Scale Upgrade', tags: ['Ecaille', 'Zora'], img: Scale },
  { name: 'Strength Upgrade', tags: ['Force'], img: Strength },
  { name: 'Iron Boots', tags: ['Botte'], img: IronBoots },
  { name: 'Hover Boots', tags: ['Botte'], img: HoverBoots },
  { name: "Zelda's Lullaby", tags: ['Song', 'Berceuse'], img: ZeldaLullaby },
  { name: "Saria's Song", tags: ['Song'], img: SariaSong },
  { name: "Epona's Song", tags: ['Song'], img: EponaSong },
  { name: "Sun's Song", tags: ['Song'], img: SunSong },
  { name: 'Song of Time', tags: ['Song'], img: SongOfTime },
  { name: 'Song of Storm', tags: ['Song'], img: SongOfStorm },
  { name: 'Prelude of Light', tags: ['Song'], img: Prelude },
  { name: 'Minuet of Forest', tags: ['Song'], img: Minuet },
  { name: 'Bolero of Fire', tags: ['Song'], img: Bolero },
  { name: 'Serenade of Water', tags: ['Song'], img: Serenade },
  { name: 'Nocturne of Shadow', tags: ['Song'], img: Nocturne },
  { name: 'Requiem of Spirit', tags: ['Song'], img: Requiem },
  { name: 'Small Key', tags: ['Key'], img: SmallKey },
  { name: 'Boss Key', tags: ['Key'], img: BossKey },
];
